import styled from 'styled-components';

import * as palette from 'pkg/config/palette';

interface PlaceholderBadgeProps extends React.SVGProps<SVGSVGElement> {
	width?: string;
	height?: string;
	viewBox?: string;
}

const PlaceholderBadge = ({
	width = '73',
	height = '72',
	viewBox = '0 0 73 72',
	...props
}: PlaceholderBadgeProps) => (
	<svg
		{...props}
		width={width}
		height={height}
		viewBox={viewBox}
		fill="none"
		xmlns="http://www.w3.org/2000/svg">
		<path
			d="M36.5 64.8C29.75 63.15 24.1625 59.329 19.7375 53.337C15.3125 47.3445 13.1 40.6905 13.1 33.375V16.2L36.5 7.20001L59.9 16.2V33.375C59.9 40.6905 57.6875 47.3445 53.2625 53.337C48.8375 59.329 43.25 63.15 36.5 64.8ZM36.5 59.175C41.7 57.5625 46 54.3375 49.4 49.5C52.8 44.6625 54.5 39.2875 54.5 33.375V19.875L36.5 12.975L18.5 19.875V33.375C18.5 39.2875 20.2 44.6625 23.6 49.5C27 54.3375 31.3 57.5625 36.5 59.175Z"
			fill={palette.gray[400]}
		/>
	</svg>
);

export default styled(PlaceholderBadge)``;
